<script>
import Vue from 'vue';

Vue.component('Profilmenu', {
  data: function() {
    return {
      left: 0,
      top: 64
    };
  },
  template: `
    <div :style="divStyle" v-if="$root.profilmenu" class="profile-overlay-menu">
      <div class="om-content">
        <div class="user-data">
          <div class="photo" :style="photoStyle">

          </div>
          <ul>
            <li><a title="Jelszó módosítás" target="_blank" href="https://user.sze.hu">Jelszó módosítás</a></li>
          </ul>
        </div>
      </div>
      <router-link class="logout" :to="{ path: '/logout' }"><i class="fa fa-power-off"></i>Kijelentkezés</router-link>
    </div>
  `,
  mounted: function() {
    var _this = this;

    Vue.nextTick(function() {
      _this.left = $('.logged-user').offset().left - 15;

      $(window).click(function(event) {
        if ($(event.target).closest('.profile-overlay-menu').length == 0 && !$(event.target).hasClass('toggle') && !$(event.target).parent().hasClass('toggle'))
          _this.$root.profilmenu = false;
      });
    });
  },
  computed: {
    divStyle: function() {
      return {
        left: this.left + 'px',
        top: this.top + 'px'
      }
    },
    photoStyle: function() {
      return {
        'background-image': "url('assets/img/"+(this.$root.user.avatar != undefined ? this.$root.user.avatar : '')+"')"
      }
    }
  }
});
</script>


// WEBPACK FOOTER //
// profilmenu.vue?e04eeab6